import repair1 from "../../../../images/content/pillar-1/repair-of-home-appliances/repair1.svg";
import repair2 from "../../../../images/content/pillar-1/repair-of-home-appliances/repair2.svg";
import repair3 from "../../../../images/content/pillar-1/repair-of-home-appliances/repair3.svg";
import repair4 from "../../../../images/content/pillar-1/repair-of-home-appliances/repair4.svg";

export const repairImages = [
	{
		id: "repair-image-1",
		imageUrl: repair1,
		imageAlt: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.images.image1Alt",
	},
	{
		id: "repair-image-2",
		imageUrl: repair2,
		imageAlt: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.images.image2Alt",
	},
	{
		id: "repair-image-3",
		imageUrl: repair3,
		imageAlt: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.images.image3Alt",
	},
	{
		id: "repair-image-4",
		imageUrl: repair4,
		imageAlt: "pages.pillar.pillar1.repairOfHomeAppliances.blocks.images.image4Alt",
	},
];